<template>
    <div class="section-images-mobile">
        <div class="images-items">
            <div class="grid-item" v-for="item in options[0].images" :key="item.img">
                <div class="item-img" :style="'background-image:url(' + item.img + ')'"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'section-images-mobile',
        props: ['options'],
        data () {
            return {
            }
        },
        computed: mapGetters({
        }),
    }
</script>

<style lang="scss">
    @import '@/styles/components/partials/respond/section-images-mobile.scss';
</style>